/**
 * Relation names shared by every root document definition. These are the camelCase form
 * of the relation names declared on the API (`Incept\Document\Constants\RootDocumentRelation`),
 * because API responses are run through a camelize keys step before reaching the app.
 */
export enum RootDocumentRelation {
  Docs = 'docs',
  Applicants = 'applicants',
  Partner = 'partner',
  Asset = 'asset',
  Quote = 'quote',
  ApplicantsAssets = 'applicantsAssets',
  ApplicantsLiabilities = 'applicantsLiabilities',
  ApplicantsExpenses = 'applicantsExpenses',
  Referees = 'referees',
}
